import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios"
// import { get } from "react-hook-form";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [signed, setSigned] = useState(false)
  const [rodada, setRodada] = useState(null)

  async function DoAForcedGet() {
    const currentUser = JSON.parse(localStorage.getItem("@App:user"))

    try {
      const response = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/usuario/obter/${currentUser.usuario}`)
      localStorage.setItem('@App:user', JSON.stringify(response.data))
      setUser(response.data)
      const responseRodada = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/rodada/obterRodadaAtiva/${currentUser.industria.industria}`)
      setRodada(responseRodada.data)
    } catch (err) {
        // Handle Error Here
        console.error(err);
    }
      
  }

  async function Login(data) {

    setSigned(true)
    setUser(data)
    localStorage.setItem('@App:user', JSON.stringify(data));

    DoAForcedGet()

  }

  function Logout() {
    setUser(null);
    setSigned(false);
    sessionStorage.removeItem('@App:user');
  }

  useEffect(() => {

    if(localStorage.getItem("@App:user")) {
      const currentUser = JSON.parse(localStorage.getItem("@App:user"))
      
      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/usuario/obter/${currentUser.usuario}`)
      .then(response => {
        localStorage.setItem('@App:user', JSON.stringify(response.data))
        setUser(response.data)
        axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/rodada/obterRodadaAtiva/${currentUser.industria.industria}`)
        .then(responseRodada => setRodada(responseRodada.data))
        .catch(error => {return error})
      })
      .catch(error => {return error})
    }

  }, [])

  return (
    <UserContext.Provider
      value={{
        user,
        signed,
        Login,
        Logout,
        rodada,
        setRodada,
        DoAForcedGet
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
